import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CtaBanner from '../components/CtaBanner';
import klikLogo from '../assets/klik_logo.png';
import touchlkLogo from '../assets/projects_icons/touchlk.png';
import paddyLogo from '../assets/projects_icons/paddy.png';
import dthlkLogo from '../assets/projects_icons/dthlk.png';
import touchlkPlusLogo from '../assets/projects_icons/touchlkplus.png';
import klikShieldLogo from '../assets/projects_icons/klikshield.png';

const CAPABILITIES = [
  { label: 'ADAS', icon: 'i-shield' },
  { label: 'DMS', icon: 'i-eye' },
  { label: 'Live Tracking', icon: 'i-live' },
  { label: 'GPS', icon: 'i-gps' },
  { label: 'Solar Powered', icon: 'i-sun' },
  { label: 'Native Android', icon: 'i-android' },
  { label: 'Native iOS', icon: 'i-mobile' },
  { label: 'AI Vision', icon: 'i-ai' },
];
const ECOSYSTEM = [
  { label: 'Mobile Apps', icon: 'i-mobile', angle: -90, top: 55, left: 210 },
  { label: 'AI Dash Cam', icon: 'i-dashcam', angle: -18, top: 148, left: 338 },
  { label: 'Dual Recording', icon: 'i-video', angle: 54, top: 299, left: 289 },
  { label: 'GPS Tracking', icon: 'i-gps', angle: 126, top: 299, left: 131 },
  { label: 'Solar CCTV', icon: 'i-cctv', angle: 198, top: 148, left: 82 },
];
const PROJECTS = [
  {
    name: 'TouchLK',
    logo: touchlkLogo,
    rating: '4.9',
    downloads: '100+ Downloads',
    link: 'https://play.google.com/store/apps/details?id=com.ananth.rechargenow&pcampaignid=web_share',
  },
  {
    name: 'Paddy Calculator',
    logo: paddyLogo,
    rating: '5.0',
    downloads: '1K+ Downloads',
    link: 'https://play.google.com/store/apps/details?id=com.ananth.asc&pcampaignid=web_share',
  },
  {
    name: 'DTHLK',
    logo: dthlkLogo,
    rating: '4.6',
    downloads: '10+ Downloads',
  },
  {
    name: 'TouchLK Plus',
    logo: touchlkPlusLogo,
    rating: '4.9',
    downloads: '300+ Downloads',
  },
  {
    name: 'Klik Shield',
    logo: klikShieldLogo,
    rating: '4.6',
    downloads: '10+ Downloads',
  },
];

export default function Home() {
  return (
    <div className="kh">
      <Header active="home" />

      <section className="kh-hero">
        <div className="kh-glow kh-glow-a" style={{ width: 520, height: 520, top: -180, left: -120 }} />
        <div className="kh-glow kh-glow-b" style={{ width: 460, height: 460, top: 60, right: -140 }} />

        <div className="kh-container kh-hero-grid" style={{ maxWidth: 1280, margin: '0 auto', padding: '0 24px', position: 'relative', display: 'grid', gap: 64, alignItems: 'center' }}>
          <div>
            <h1 className="kh-fade-1 kh-hero-title">
              Innovating the future<br />with <span style={{ color: 'var(--accent)' }}>smart technology</span> solutions
            </h1>
            <p className="kh-fade-3 kh-hero-sub">
              KLIK Innovatech builds native Android &amp; iOS apps and AI-powered safety hardware &mdash; vehicle dash cams, GPS trackers and solar CCTV &mdash; engineered and controlled end-to-end by our own team.
            </p>
            <div className="kh-fade-4" style={{ display: 'flex', alignItems: 'center', gap: 16, marginTop: 36, flexWrap: 'wrap' }}>
              <a href="#contact" className="kh-btn-primary">Start a Project <svg width="16" height="16"><use href="#i-arrow" /></svg></a>
              <a href="#services-grid" className="kh-btn-ghost">Explore Services</a>
            </div>
            <div className="kh-fade-4" style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 34, color: 'var(--faint)', fontSize: 13.5, fontWeight: 500 }}>
              <span>100% Native</span><span style={{ opacity: 0.5 }}>&middot;</span><span>No Cross&#8209;Platform</span><span style={{ opacity: 0.5 }}>&middot;</span><span>Self&#8209;Built Systems</span>
            </div>
          </div>

          <div className="kh-hero-visual">
            <div className="kh-hero-panel" style={{ padding: '28px 20px 20px' }}>
              <div className="kh-glow" style={{ width: 260, height: 260, top: -60, left: -60 }} />
              <div className="kh-glow kh-glow-b" style={{ width: 220, height: 220, bottom: -60, right: -40 }} />
              <p style={{ position: 'relative', textAlign: 'center', fontSize: 11.5, fontWeight: 700, letterSpacing: '0.12em', color: 'var(--faint)', textTransform: 'uppercase' }}>One Ecosystem, Five Solutions</p>
              <div style={{ position: 'relative', width: '100%', height: 380, marginTop: 8 }}>
                {ECOSYSTEM.map((s) => (
                  <div
                    key={`line-${s.label}`}
                    style={{
                      position: 'absolute', top: 190, left: 210, width: 135, height: 2,
                      background: 'linear-gradient(90deg, var(--accent), transparent)',
                      transformOrigin: '0 50%', transform: `rotate(${s.angle}deg)`, opacity: 0.35,
                    }}
                  />
                ))}

                <div style={{ position: 'absolute', top: 190, left: 210, transform: 'translate(-50%, -50%)', width: 96, height: 96, borderRadius: '50%', background: 'var(--chipbg)', border: '1px solid var(--chipborder)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 0 44px var(--glowa)' }}>
                  <img src={klikLogo} alt="KLIK" style={{ width: 52, height: 'auto' }} />
                </div>

                {ECOSYSTEM.map((s) => (
                  <div key={s.label} style={{ position: 'absolute', top: s.top, left: s.left, transform: 'translate(-50%, -50%)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
                    <div style={{ width: 60, height: 60, borderRadius: 16, background: 'var(--panel)', border: '1px solid var(--chipborder)', boxShadow: 'var(--shadow)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--accent)' }}>
                      <svg width="24" height="24"><use href={`#${s.icon}`} /></svg>
                    </div>
                    <span style={{ fontSize: 10.5, fontWeight: 700, color: 'var(--text)', whiteSpace: 'nowrap' }}>{s.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="kh-tech-strip">
        <p className="kh-strip-label">BUILT-IN CAPABILITIES</p>
        <div className="kh-marquee-mask">
          <div className="kh-marquee-track">
            {CAPABILITIES.concat(CAPABILITIES).map((cap, i) => (
              <div className="kh-cap-card" key={i}>
                <div className="kh-cap-icon"><svg width="22" height="22"><use href={`#${cap.icon}`} /></svg></div>
                <span className="kh-cap-label">{cap.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="kh-container" style={{ maxWidth: 1280, margin: '0 auto', padding: '64px 24px' }}>
        <div className="kh-stats-grid">
          <div style={{ textAlign: 'center' }}>
            <h3 className="kh-stat-num">10+</h3>
            <p className="kh-stat-label">Apps Delivered</p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <h3 className="kh-stat-num">20+</h3>
            <p className="kh-stat-label">Clients</p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <h3 className="kh-stat-num">1+</h3>
            <p className="kh-stat-label">Years of Excellence</p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <h3 className="kh-stat-num">5</h3>
            <p className="kh-stat-label">Core Solutions</p>
          </div>
        </div>
      </section>

      <section id="services-grid" className="kh-container" style={{ maxWidth: 1280, margin: '0 auto', padding: '40px 24px 80px' }}>
        <div style={{ textAlign: 'center', maxWidth: 640, margin: '0 auto 56px' }}>
          <div className="kh-eyebrow"><span className="kh-dot" />WHAT WE DO</div>
          <h2 className="kh-h2" style={{ marginTop: 18 }}>Five solutions, one accountable team</h2>
          <p className="kh-lede">From the app on your phone to the hardware watching your vehicle or property &mdash; we build and control the full system ourselves.</p>
        </div>

        <div className="kh-services-grid kh-services-grid-3">
          <div className="kh-card">
            <div className="kh-icon-badge"><svg width="24" height="24"><use href="#i-mobile" /></svg></div>
            <h3 className="kh-card-title">Mobile App Development</h3>
            <p className="kh-card-body">100% native Android &amp; iOS apps built to your requirements &mdash; no cross-platform shortcuts, so performance stays uncompromised.</p>
            <a href="#!" className="kh-card-link">Learn more <svg width="14" height="14"><use href="#i-arrow" /></svg></a>
          </div>
          <div className="kh-card">
            <div className="kh-icon-badge"><svg width="24" height="24"><use href="#i-dashcam" /></svg></div>
            <h3 className="kh-card-title">AI Vehicle Safety Dash Cam</h3>
            <p className="kh-card-body">ADAS and driver monitoring (DMS) with live monitoring and live tracking &mdash; the full system designed and controlled in-house.</p>
            <a href="#!" className="kh-card-link">Learn more <svg width="14" height="14"><use href="#i-arrow" /></svg></a>
          </div>
          <div className="kh-card">
            <div className="kh-icon-badge"><svg width="24" height="24"><use href="#i-video" /></svg></div>
            <h3 className="kh-card-title">Front &amp; Rear Dash Cam Recording</h3>
            <p className="kh-card-body">Simultaneous front (2K/4K) and rear video recording, so both directions are covered on every drive.</p>
            <a href="#!" className="kh-card-link">Learn more <svg width="14" height="14"><use href="#i-arrow" /></svg></a>
          </div>
          <div className="kh-card">
            <div className="kh-icon-badge"><svg width="24" height="24"><use href="#i-gps" /></svg></div>
            <h3 className="kh-card-title">Vehicle GPS Tracking</h3>
            <p className="kh-card-body">Real-time location tracking solutions built for fleets and individual vehicles, viewable from anywhere.</p>
            <a href="#!" className="kh-card-link">Learn more <svg width="14" height="14"><use href="#i-arrow" /></svg></a>
          </div>
          <div className="kh-card">
            <div className="kh-icon-badge"><svg width="24" height="24"><use href="#i-cctv" /></svg></div>
            <h3 className="kh-card-title">AI Solar CCTV Cameras</h3>
            <p className="kh-card-body">Solar-powered, AI-enabled surveillance cameras &mdash; independent of mains power, watching what matters most.</p>
            <a href="#!" className="kh-card-link">Learn more <svg width="14" height="14"><use href="#i-arrow" /></svg></a>
          </div>
        </div>
      </section>

      <section className="kh-container" style={{ maxWidth: 1280, margin: '0 auto', padding: '0 24px 90px' }}>
        <div style={{ textAlign: 'center', maxWidth: 600, margin: '0 auto 44px' }}>
          <div className="kh-eyebrow"><span className="kh-dot" />OUR PROJECTS</div>
          <h2 className="kh-h2" style={{ fontSize: 30, marginTop: 18 }}>Trusted by 20+ clients</h2>
          <p className="kh-lede">A selection of products we've delivered and continue to support.</p>
        </div>
        <div className="kh-project-grid">
          {PROJECTS.map((p) => (
            <div className="kh-project-card" key={p.name}>
              <div className="kh-project-icon">
                <img src={p.logo} alt={p.name} />
              </div>
              <p className="kh-project-name">{p.name}</p>
              <div className="kh-project-meta">
                <span className="kh-project-rating"><svg width="14" height="14"><use href="#i-star" /></svg>{p.rating}</span>
                <span className="kh-project-downloads"><svg width="14" height="14"><use href="#i-download" /></svg>{p.downloads}</span>
              </div>
              {p.link && (
                <a href={p.link} target="_blank" rel="noopener noreferrer" className="kh-project-cta">View on Play Store</a>
              )}
            </div>
          ))}
        </div>
      </section>

      <section id="about" className="kh-alt-section">
        <div className="kh-container kh-whyus-grid" style={{ maxWidth: 1280, margin: '0 auto', padding: '0 24px' }}>
          <div className="kh-whyus-visual">
            <div className="kh-glow" style={{ width: 280, height: 280, top: -60, left: -60 }} />
            <div className="kh-glow" style={{ width: 240, height: 240, bottom: -60, right: -40 }} />
            <div style={{ position: 'relative', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 18 }}>
              <div className="kh-icon-badge" style={{ width: 120, height: 120, borderRadius: 28 }}>
                <svg width="54" height="54"><use href="#i-shield" /></svg>
              </div>
              <p className="kh-caption">Built &amp; controlled in&#8209;house</p>
            </div>
          </div>

          <div>
            <div className="kh-eyebrow"><span className="kh-dot" />WHY KLIK</div>
            <h2 className="kh-h2" style={{ marginTop: 18 }}>Why businesses choose KLIK</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 22, marginTop: 30 }}>
              <div className="kh-check-row">
                <div className="kh-check-badge"><svg width="14" height="14"><use href="#i-check" /></svg></div>
                <div><h3 className="kh-check-title">Native-only development</h3><p className="kh-check-body">We don't build cross-platform apps. Android and iOS are built natively, so performance is never compromised.</p></div>
              </div>
              <div className="kh-check-row">
                <div className="kh-check-badge"><svg width="14" height="14"><use href="#i-check" /></svg></div>
                <div><h3 className="kh-check-title">Full system, one team</h3><p className="kh-check-body">Our dash cam, GPS and CCTV systems are designed, built and controlled by us end-to-end &mdash; hardware, cloud and app.</p></div>
              </div>
              <div className="kh-check-row">
                <div className="kh-check-badge"><svg width="14" height="14"><use href="#i-check" /></svg></div>
                <div><h3 className="kh-check-title">Proven with real clients</h3><p className="kh-check-body">Products already live for TouchLK, Paddy Calculator, DTHLK, TouchLK Plus and Klik Shield.</p></div>
              </div>
              <div className="kh-check-row">
                <div className="kh-check-badge"><svg width="14" height="14"><use href="#i-check" /></svg></div>
                <div><h3 className="kh-check-title">Direct access to engineers</h3><p className="kh-check-body">Talk to the people building your product on WhatsApp or a call &mdash; not a ticket queue.</p></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="kh-container" style={{ maxWidth: 1280, margin: '0 auto', padding: '90px 24px 0' }}>
        <div style={{ textAlign: 'center', maxWidth: 640, margin: '0 auto 40px' }}>
          <div className="kh-eyebrow"><span className="kh-dot" />RESEARCH &amp; DEVELOPMENT</div>
          <h2 className="kh-h2" style={{ fontSize: 30, marginTop: 18 }}>What we're building next</h2>
          <p className="kh-lede">Upcoming ideas currently in research and development &mdash; not yet available.</p>
        </div>
        <div className="kh-upcoming-grid">
          <div className="kh-upcoming-card">
            <span className="kh-upcoming-badge">Upcoming</span>
            <div className="kh-icon-badge" style={{ width: 56, height: 56, borderRadius: 16 }}><svg width="24" height="24"><use href="#i-home" /></svg></div>
            <h3 className="kh-card-title" style={{ fontSize: 18, marginTop: 18 }}>Smart Home System</h3>
            <p className="kh-card-body">Control your entire home from your phone &mdash; IoT devices and sensors automate lighting, security and more.</p>
          </div>
          <div className="kh-upcoming-card">
            <span className="kh-upcoming-badge">Upcoming</span>
            <div className="kh-icon-badge" style={{ width: 56, height: 56, borderRadius: 16 }}><svg width="24" height="24"><use href="#i-leaf" /></svg></div>
            <h3 className="kh-card-title" style={{ fontSize: 18, marginTop: 18 }}>Smart Agriculture</h3>
            <p className="kh-card-body">Automated water scheduling with solar-powered CCTV monitoring, plus animal alerts for elephants, cattle, goats and intruders.</p>
          </div>
        </div>
      </section>

      <CtaBanner />
      <Footer />
    </div>
  );
}
